<script lang="ts">
  import Button from './Button.svelte';
  import DayOfTheMonth from './DayOfTheMonth.svelte';

  interface Props {
    mobileInput?: HTMLDivElement;
    html: string | undefined;
    id: string | undefined;
    day: number;
    scrollToPosition: () => void;
    event?: string;
    onClick?: () => void;
    onUpdateValue?: (detail: any) => void; // Consider using a more specific type
    onDeleteValue?: (detail: any) => void; // Consider using a more specific type
  }

  let {
    mobileInput = $bindable(),
    html,
    id,
    day,
    scrollToPosition,
    event = '',
    onClick = () => {},
    onUpdateValue = () => {},
    onDeleteValue = () => {},
  }: Props = $props();

  let scrolled = false;
  function handleScrollToPositionOnce() {
    if (!scrolled) {
      scrollToPosition();
      scrolled = true;
    }
  }
</script>

<div class="mobile-data" bind:this={mobileInput}>
  <button class="close-btn" onclick={onClick} aria-label="Close"
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      ><path d="M0 0h24v24H0V0z" fill="none" /><path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
      /></svg
    ></button
  >
  <DayOfTheMonth
    {html}
    {id}
    {day}
    {event}
    {onUpdateValue}
    {onDeleteValue}
    onClick={handleScrollToPositionOnce}
    override
  />
</div>
<div class="done">
  <Button width="full" size="medium" {onClick}>Done</Button>
</div>

<style>
  .done,
  .mobile-data {
    display: none;
  }

  .close-btn {
    display: grid;
    place-items: center;
    line-height: 32px;
    vertical-align: center;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    border: 2px solid var(--primary);
    padding: 0;
    background-color: white;
    transform: scale(0.9);
    position: absolute;
    top: -12px;
    right: -12px;
    z-index: 1;
  }

  .close-btn svg {
    fill: var(--primary);
  }

  @media screen and (max-width: 768px) {
    .mobile-data {
      position: relative;
      display: block;
      grid-column: 1 / -1;
      margin-top: 1rem;
    }
    .done {
      display: block;
      grid-column: 1 / -1;
    }
  }
</style>
